<template>
  <!-- 企业服务-代理管理-发票开入 -->
  <div class="Invoice-body">
    <!-- 筛选 -->
    <el-form
      :model="screenData"
      :inline="true"
      class="screen"
      @submit.native.prevent="handelSearch"
    >
      <el-form-item label="销售方：">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.input" placeholder="请输入销售方"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="纳税人识别号(身份证/信用代码)：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.code" placeholder="请输入身份证/信用代码"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="手机号：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.phone" placeholder="请输入手机号"></el-input>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：">
      <el-date-picker
      v-model="screenData.value"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="screenData.value = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>

    <!-- 列表 -->
    <div class="Table">
      <el-table :data="tableData">
        <el-table-column prop="name" label="销售方" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="creditCode"
          label="纳税人识别号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="phone" label="电话" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="total" label="已开入票数"> </el-table-column>
        <el-table-column
          prop="createTime"
          label="最新开票时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="span-Operation" @click="handelHistory(scope.row)"
              >历史发票</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 底部分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <WinTable
      :VisibleHistory="VisibleHistory"
      :distinguish="'enter'"
      :row="row"
      @handleCloseHistory="VisibleHistory = false"
      @handelDetails="handelDetails"
    ></WinTable>

    <!-- //详情/申请退款弹窗 -->
    <DeOfRe
      :row="Details"
      :VisibleDeRe="VisibleDeRe"
      :DeRe="0"
      @handleCloseDeRe="VisibleDeRe = false"
    ></DeOfRe>
  </div>
</template>

<script>
import {
  invoiceInStatistics, //已开入统计列表
} from "../../../../../assets/api/Agency/Enterprise";
import DeOfRe from "../Enterprise/Bookkeeping/components/InvoiceCom/NewDetails.vue";
import WinTable from "./components/WinTable.vue";
// 引入分页组件
import paging from "../../../../../components/paging.vue";
export default {
  data() {
    return {
      screenData: {
        value: null, // 时间（daterange 清空需为 null）
        input: "", //企业名称
        code: "", //纳税人识别号
        phone: "", //手机号
      },
      tableData: [],

      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      VisibleHistory: false, //历史发票
      dialogIssue: false, //代开发票
      VisibleDeRe: false, //代开发票详情
      DeRe: 0,
      Details: {}, //查看详情
      row: {}, //开票
    };
  },
  watch: {},
  components: {
    paging,
    WinTable,
    // OpenInvoice, // 代开发票
    DeOfRe, // 详情
  },
  created() {
    this.invoiceInStatistics(); // 已开入统计列表
  },
  destroyed() {},
  methods: {
    //重置
    handelReset() {
      this.pagingObj.currentPage = 1;
      this.screenData = {
        value: null, // 时间
        input: "", //企业名称
        code: "", //纳税人识别号
        phone: "", //手机号
      };
      this.invoiceInStatistics(); // 已开入统计列表
    },
    //搜索
    handelSearch() {
      this.pagingObj.currentPage = 1;
      this.invoiceInStatistics(); // 已开入统计列表
    },
    // 已开入统计列表
    invoiceInStatistics() {
      // 处理时间（叉号清空后为 null，需先判断再取下标）
      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          name: this.screenData.input, //名称
          creditCode: this.screenData.code, //统一代码
          phone: this.screenData.phone, //电话
          startTime: time,
          endTime: timeEnd,
        },
      };
      invoiceInStatistics(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 点击查看开票详情
    handelDetails(row) {
      this.Details = row;
      this.VisibleDeRe = true;
    },

    // 历史
    handelHistory(row) {
      this.row = row;
      this.VisibleHistory = true;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.invoiceInStatistics(); // 已开入统计列表
    },

  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
.Invoice-body {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  // 筛选
  .screen {
    margin-top: 10px;
    margin-bottom: 0;
    position: relative;
}
  //   表格
  .Table {
    min-height: 450px;
    margin-top: 30px;
    .el-table {
      border: 1px solid #eeeeee;
    }
    .span-Operation {
      color: #409eff ;
      margin-left: 10px;
      cursor: pointer;
    }
    .span-Operation:nth-child(1) {
      margin-left: 0px;
    }
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
